// extracted by mini-css-extract-plugin
module.exports = {"ChatArea":"WithChat_ChatArea__I1LEp","Header":"WithChat_Header__KV7u7"};